import { render } from "./AccessGroupsRadio.vue?vue&type=template&id=a7b86a8c"
import script from "./AccessGroupsRadio.vue?vue&type=script&lang=js"
export * from "./AccessGroupsRadio.vue?vue&type=script&lang=js"
script.render = render

export default script